module.exports = __webpack_public_path__ + "img/LOGO_DESPACHO_CONTABLE.a738b8d6.png";